"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Marketing_Starter = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/productIcons/Marketing_Starter.svg"));

var _Marketing_Pro = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/productIcons/Marketing_Pro.svg"));

var _Marketing_Ent = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/productIcons/Marketing_Ent.svg"));

var _Sales_Starter = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/productIcons/Sales_Starter.svg"));

var _Sales_Pro = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/productIcons/Sales_Pro.svg"));

var _Sales_Ent = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/productIcons/Sales_Ent.svg"));

var _Service_Starter = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/productIcons/Service_Starter.svg"));

var _Service_Pro = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/productIcons/Service_Pro.svg"));

var _Service_Ent = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/productIcons/Service_Ent.svg"));

var _CMS_Pro = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/productIcons/CMS_Pro.svg"));

var _CMS_Ent = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/productIcons/CMS_Ent.svg"));

var _Hubs = _interopRequireDefault(require("self-service-api/constants/Hubs"));

var Editions = _interopRequireWildcard(require("self-service-api/constants/Editions"));

var _Hubs$HUB_MARKETING, _Hubs$HUB_SALES, _Hubs$HUB_SERVICE, _Hubs$HUB_CMS, _Hubs$HUB_MARKETING$H;

var _default = (_Hubs$HUB_MARKETING$H = {}, (0, _defineProperty2.default)(_Hubs$HUB_MARKETING$H, _Hubs.default.HUB_MARKETING, (_Hubs$HUB_MARKETING = {}, (0, _defineProperty2.default)(_Hubs$HUB_MARKETING, Editions.STARTER, _Marketing_Starter.default), (0, _defineProperty2.default)(_Hubs$HUB_MARKETING, Editions.PROFESSIONAL, _Marketing_Pro.default), (0, _defineProperty2.default)(_Hubs$HUB_MARKETING, Editions.ENTERPRISE, _Marketing_Ent.default), _Hubs$HUB_MARKETING)), (0, _defineProperty2.default)(_Hubs$HUB_MARKETING$H, _Hubs.default.HUB_SALES, (_Hubs$HUB_SALES = {}, (0, _defineProperty2.default)(_Hubs$HUB_SALES, Editions.STARTER, _Sales_Starter.default), (0, _defineProperty2.default)(_Hubs$HUB_SALES, Editions.PROFESSIONAL, _Sales_Pro.default), (0, _defineProperty2.default)(_Hubs$HUB_SALES, Editions.ENTERPRISE, _Sales_Ent.default), _Hubs$HUB_SALES)), (0, _defineProperty2.default)(_Hubs$HUB_MARKETING$H, _Hubs.default.HUB_SERVICE, (_Hubs$HUB_SERVICE = {}, (0, _defineProperty2.default)(_Hubs$HUB_SERVICE, Editions.STARTER, _Service_Starter.default), (0, _defineProperty2.default)(_Hubs$HUB_SERVICE, Editions.PROFESSIONAL, _Service_Pro.default), (0, _defineProperty2.default)(_Hubs$HUB_SERVICE, Editions.ENTERPRISE, _Service_Ent.default), _Hubs$HUB_SERVICE)), (0, _defineProperty2.default)(_Hubs$HUB_MARKETING$H, _Hubs.default.HUB_CMS, (_Hubs$HUB_CMS = {}, (0, _defineProperty2.default)(_Hubs$HUB_CMS, Editions.PROFESSIONAL, _CMS_Pro.default), (0, _defineProperty2.default)(_Hubs$HUB_CMS, Editions.ENTERPRISE, _CMS_Ent.default), _Hubs$HUB_CMS)), _Hubs$HUB_MARKETING$H);

exports.default = _default;
module.exports = exports.default;